import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/close.svg'


const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = { class: "pane" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "wrap-title" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "color" }
const _hoisted_8 = { class: "color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text" }, "快递信息", -1)),
        _createElementVNode("img", {
          src: _imports_0,
          alt: "X",
          class: "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info?.items, (order, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "wrap",
            key: idx
          }, [
            _createElementVNode("h4", _hoisted_5, "订单 " + _toDisplayString(idx+1), 1),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, "下单时间: " + _toDisplayString(order.time), 1),
              _createElementVNode("div", null, "快递单号: " + _toDisplayString(order.express), 1),
              _createElementVNode("div", null, "订单号: " + _toDisplayString(order.order_id), 1),
              _createElementVNode("div", _hoisted_7, "选购号码: " + _toDisplayString(order.number), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order?.trace, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: index
              }, [
                _createElementVNode("div", null, _toDisplayString(item.content), 1),
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.time), 1)
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", {
      class: "overlay",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
    })
  ]))
}